import React from "react";

const EventRequestIcon = () => {
  return (
    <div>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
      >
        <path
          d="M5 1.25C5 0.904822 4.72019 0.625 4.375 0.625C4.02981 0.625 3.75 0.904822 3.75 1.25V2.1875H2.5C1.46447 2.1875 0.625 3.02697 0.625 4.0625V14.6875C0.625 15.723 1.46447 16.5625 2.5 16.5625H9.38256C9.24191 16.1645 9.14475 15.7459 9.09684 15.3125H2.5C2.15482 15.3125 1.875 15.0327 1.875 14.6875V6.875H16.25V9.28234C16.6914 9.40972 17.1105 9.58969 17.5 9.81503V4.0625C17.5 3.02697 16.6605 2.1875 15.625 2.1875H14.375V1.25C14.375 0.904822 14.0952 0.625 13.75 0.625C13.4048 0.625 13.125 0.904822 13.125 1.25V2.1875H5V1.25Z"
          fill="#414651"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M19.375 14.6875C19.375 12.0987 17.2763 10 14.6875 10C12.0987 10 10 12.0987 10 14.6875C10 17.2763 12.0987 19.375 14.6875 19.375C17.2763 19.375 19.375 17.2763 19.375 14.6875ZM16.503 13.3911C16.65 13.0788 16.5159 12.7065 16.2036 12.5595C15.8913 12.4125 15.519 12.5466 15.372 12.8589L14.3337 15.0653L13.9297 14.5491C13.7171 14.2772 13.3243 14.2292 13.0524 14.442C12.7805 14.6547 12.7326 15.0475 12.9453 15.3193L13.9747 16.6351C14.1084 16.806 14.3212 16.8953 14.5368 16.8711C14.7524 16.8468 14.94 16.7125 15.0324 16.5161L16.503 13.3911Z"
          fill="#414651"
        />
      </svg>
    </div>
  );
};

export default EventRequestIcon;
